$('.banner-slides').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  arrows: false,
  asNavFor: '.colors'
});
$('.colors').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.banner-slides',
  focusOnSelect: true,
  centerMode: true,
  draggable: false,
  centerPadding: '0px',
  variableWidth: true
});
$('.colors .slick-arrow').text("");
$('.product-tabs ul.tabs li:first-child > a').addClass('active');